import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Storage } from 'src/app/models/storage';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material';
import _ from 'lodash';
import { EDGE } from 'src/app/data/storage';

@Component({
  selector: 'app-nonstandard-window',
  templateUrl: './nonstandard-window.component.html',
})
export class NonstandardWindowComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  storage: Storage;
  @Input() windowKey: number;

  side: 'INSIDE' | 'OUTSIDE';

  constructor(
    private storageService: StorageService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;
    this.storageSubscription();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;

      this.side = this.storage.windows[this.windowKey].nonstandard.side;
    });
  }

  handleAddEdge() {
    const storage = _.cloneDeep(this.storageService.storage);

    if (storage.windows[this.windowKey].nonstandard.inside.edges.length === 0) {
      storage.windows[this.windowKey].nonstandard.inside.edges.push(
        _.cloneDeep(EDGE)
      );
    } else{
      storage.windows[this.windowKey].nonstandard.inside.edges.push(
        _.cloneDeep(storage.windows[this.windowKey].nonstandard.inside.edges[0])
      );
    }

    if (storage.windows[this.windowKey].nonstandard.outside.edges.length === 0) { 
      storage.windows[this.windowKey].nonstandard.outside.edges.push(
        _.cloneDeep(EDGE)
      );
    } else {
      storage.windows[this.windowKey].nonstandard.outside.edges.push(
        _.cloneDeep(storage.windows[this.windowKey].nonstandard.outside.edges[0])
      );
    }

    this.storageService.storage = storage;
  }

  setWindowSide(side: string) {
    const storage = this.storage;
    storage.windows[this.windowKey].nonstandard.side = side;

    this.storageService.storage = storage;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  changeAreOutsideEdgesSameAsInsideEdges() {
    const storage = this.storage;
    storage.windows[this.windowKey].nonstandard.outside = _.cloneDeep(storage.windows[this.windowKey].nonstandard.inside);

    this.storageService.storage = storage;
  }

  getSideName(staticName: string) {
    switch (staticName) {
      case 'INSIDE':
        return 'inside';
      case 'OUTSIDE':
        return 'outside';
    }
  }

}
